import React from "react"
import StockIdentificationUpdate from "./StockIdentificationUpdate"
import DataCard from "components/Common/DataCard"
import { prepareDataWithLoading } from "helpers/loading_helper"

export default function Identification({ stock, loading = false }) {
  const fields = [
    { label: "Stock ID", value: stock?.stock_id },
    { label: "Chassis Number", value: stock?.full_chassis },
    { label: "Engine Number", value: stock?.full_engine },
    { label: "BRTA Reg No", value: stock?.brta_reg_no },
  ]

  const data = prepareDataWithLoading(fields, loading)

  return (
    <DataCard
      title="Identification"
      icon="bx bx-barcode"
      data={data}
      action={loading ? null : <StockIdentificationUpdate stock={stock} />}
    />
  )
}
